var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAirlineGroundHandling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m21.274 15.855-7.756-2.415v5.317l1.95 1.463v1.44l-3.39-.952-3.367.952v-1.44l1.904-1.463V13.44l-7.709 2.415V13.95l7.71-4.854V3.78q0-.604.417-1.022a1.42 1.42 0 0 1 1.045-.418 1.41 1.41 0 0 1 1.44 1.44v5.317l7.756 4.854z"
})));
export default SvgAirlineGroundHandling;